import React from "react";
import { Link } from "react-router-dom";
import content from "../content/content.json";

const ContactBanner = () => {
  const { contactBanner, shared } = content;

  return (
    <section
      className="w-full relative bg-cover bg-center bg-no-repeat flex justify-center items-center min-h-[450px] px-6 md:px-10 lg:px-16 py-20"
      style={{
        backgroundImage: `url('${contactBanner.backgroundImage}')`,
      }}
    >
      <div className="relative bg-white/50 backdrop-blur-md shadow-lg w-full max-w-7xl flex flex-col md:flex-row justify-between items-start md:items-center gap-10 px-8 md:px-12 py-12 rounded-none">
        <div className="md:w-1/2">
          <h4 className="text-[#007681] font-semibold text-md mb-3">{contactBanner.eyebrow}</h4>
          <h2 className="text-4xl md:text-4xl font-bold text-gray-900">{contactBanner.heading}</h2>
        </div>

        <div className="md:w-1/2 text-md text-gray-700 leading-relaxed">
          <p className="mb-6">{contactBanner.description}</p>

          <Link to="/contact" className="learn-more-btn group relative overflow-hidden bg-[#E4002B] border border-[#E4002B] px-8 py-4 font-semibold rounded-none inline-flex items-center gap-2">
            <span className="relative z-10 text-white group-hover:text-[#E4002B] transition-colors duration-300">
              {contactBanner.button}
            </span>
            <span className="relative z-10 text-white text-xl group-hover:text-[#E4002B] transition-colors duration-300">
              {shared.arrow}
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ContactBanner;

